module.exports = __webpack_public_path__ + "static/media/carot.b2740e0b.svg";